// extracted by mini-css-extract-plugin
module.exports = {"btn":"RegisterSytemUserForm_btn__1eHns"};